import { React, useState } from "react";
import { Steps } from "./Steps/steps";
export const HowToPlay = () => {
  const [termAndConditionModalVisible, setTermAndConditionModalVisible] =
    useState(false);

  const [checkRewardsPointsStructure, setCheckRewardsPointsStructure] =
    useState(false);

  const handleTermAndConditionModal = (e) => {
    e.preventDefault();
    setTermAndConditionModalVisible(true);
  };
  const checkRewardsPointsStructureModal = (e) => {
    e.preventDefault();
    setCheckRewardsPointsStructure(true);
  };

  return (
    <>
      <div className="howToPlayContainer" id="howToPlay">
        <div className="howToPlayInnerLeftContainer"></div>
        <div className="howToPlayInnerRightContainer"></div>
        <div className="container">
          <div className="howToPlayHeading">How to Play?</div>
          <div className="steps mt-5">
            <div>
              <Steps
                step={1}
                heading={"Participate"}
                icon={"../images/iplContest/participateIcon.png"}
                text={"Join the fun! Answer & unlock exclusive coupons!"}
              />
            </div>
            <div>
              <Steps
                step={2}
                heading={"Answer"}
                icon={"../images/iplContest/answerIcon.png"}
                text={
                  "Get it right, climb the leaderboard, and get closer to match tickets!"
                }
              />
            </div>
            <div>
              <Steps
                step={3}
                heading={"Win"}
                icon={"../images/iplContest/winIcon.png"}
                text={"Stay on top & win tickets—easy, fun, and rewarding!"}
              />
            </div>
          </div>
          <div className="text-center mt-3 howtoPlayCaption">
            The contest starts at 7.00 am on 21st Mar’25 and ends at 7.00 pm on
            23th May’25
          </div>
          <div className="tandcWrapper d-md-flex justify-content-between">
            <a
              href="#"
              className="d-block d-md-inline mb-4 mb-md-0 text-center"
              onClick={handleTermAndConditionModal}
            >
              Check Terms & Conditions
            </a>
            <a href="#" onClick={checkRewardsPointsStructureModal}>
              Check Rewards & Points Structure
            </a>
          </div>
        </div>
      </div>

      <div
        className={`modal championsTrophyTermConditionModal ${
          checkRewardsPointsStructure ? "show" : "fade"
        }`}
        id="exampleModal1"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel1"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header-custom">
              <h5 className="modal-title" id="exampleModalLabel1">
                Rewards & Points Structure
              </h5>
              <button
                type="button"
                className="close-custom"
                data-dismiss="modal1"
                aria-label="Close"
              >
                <span
                  aria-hidden="true"
                  onClick={() => setCheckRewardsPointsStructure(false)}
                >
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="termConditions">
                <h6>Reward Structure</h6>
                <ul>
                  <li>
                    Participation reward to everyone - VZY 150 coupon, can be
                    redeemed with PGAR / can also be gifted to friends & family
                    coupon is generic can be redeemed by anyone, but we need to
                    know which participants assigned coupon got redeemed
                  </li>
                  <li>
                    Rewards - Top 25 of the leaderboard will win 1500 Rupees
                    worth EMT voucher
                  </li>
                  <li>
                    (Week starts from Saturday & ends on Friday - leaderboard
                    prizes are announced every Friday at 11 PM)
                  </li>
                  <li>
                    Overall contest rewards - Top 3 of the Overall Leaderboard -
                    get 2 tickets (each) for the Qualifiers or the Finals
                    (announced on 24th May).
                  </li>
                </ul>

                <h6 className="mt-4">Leaderboard Calculation</h6>
                <ul>
                  <li>
                    {" "}
                    Contest Participation Points = 1 point (for every match
                    prediction submitted)
                  </li>
                  <li>
                    {" "}
                    Correct Prediction Points = 5 points (for every correct
                    match winner prediction; no points in case of a tie; no
                    points in case the match gets washed out)
                  </li>
                  <li>
                    vzy Coupon Redemption Bonus Points = 50 points (for every
                    vzy 150 coupon redeemed, either by themselves or by gifting
                    to a friend / family)
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal championsTrophyTermConditionModal ${
          termAndConditionModalVisible ? "show" : "fade"
        }`}
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header-custom">
              <h5 className="modal-title" id="exampleModalLabel">
                Term and Conditions for predict and win contest for IPL – 2025
                vzy
              </h5>
              <button
                type="button"
                className="close-custom"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span
                  aria-hidden="true"
                  onClick={() => setTermAndConditionModalVisible(false)}
                >
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="termConditions">
                <ol className="pl-4">
                  <li>
                    These terms and conditions shall govern the Predict & Win
                    Contest for IPL 2025 - vzy (hereinafter referred to as{" "}
                    <strong>“Contest”</strong>) conducted by Dish Infra Services
                    Private Limited (hereinafter referred to as{" "}
                    <strong>‘Company’</strong>) for its vzy Users (
                    <em>as defined below</em>).
                  </li>
                  <li>
                    The Contest shall run during the period from 22<sub>nd</sub>{" "}
                    March 2025 onwards and continue till 23<sub>th</sub> May
                    2025 (<strong>“Term”</strong>).
                  </li>
                  <li>
                    Eligibility to participate in the Contest: All vzy Users
                    shall be eligible to participate in the Contest. “vzy Users”
                    for the purpose of this Contest shall mean and include (i)
                    all digitally acquired active subscribers of vzy, (ii)
                    digitally acquired watcho users who are de-active since
                    seven days (DA1 to DA7), (iii) digitally acquired watcho
                    users who are de-active since 90 days (DA8 to DA90 days),
                    (iv) B2B subscribers who are de-active since DA30 to DA90
                    days , (v) watcho users who has never subscribed vzy plans
                    but have at least viewed once on vzy app / vzy website in
                    the last 90 days from the date of commencement of the
                    Contest and any other users who participates on becoming
                    aware of the Contest through promotion on our social media
                    handles etc.
                  </li>
                  <li>
                    DTH Subscribers of Dish TV India Limited under its brands
                    ‘dishtv’, ‘d2h’ and ‘zing’ brands are not entitled to
                    participate in Contest. However, DTH Subscribers having
                    standalone vzy subscription plans are eligible to
                    participate. The employees of the Company and their family
                    members, Company’s associate companies, trade partners,
                    advertising and promotional agencies and auditors /
                    executing agencies are not entitled to participate in the
                    Contest. Minors are not allowed to participate in this
                    Contest.
                  </li>
                  <li>
                    By participating in the Contest, the participants
                    (hereinafter referred to as Participants/You/Your) has/have
                    read and understood these T&C stated herein. You hereby
                    agree and confirm that your participation in the Contest is
                    subject to your unconditional acceptance to comply with the
                    T&C stated herein.
                  </li>
                  <li>
                    No purchase or payment is required to participate in this
                    Contest. Participation shall be solely on voluntary basis.
                  </li>
                  <li>
                    During the Term of the Contest, a Participant shall be
                    required to predict the winner of the respective match being
                    played between two teams (“Daily Predictions”), by selecting
                    one of the options assigned to the said team from his/her
                    Registered Mobile Number (RMN) only.
                  </li>
                  <li>
                    <p>Prediction Window :</p>
                    <ul className="roman">
                      <li>
                        The prediction window shall open every day at 12:30
                        hours AM and shall close at 7 PM.
                      </li>
                      <li>
                        For double header matches (two matches to be played on a
                        same day), prediction for both matches will open at
                        12:30 AM but the contest window for the first match will
                        close at 3 PM and contest window for the second match
                        will close at 7 PM and Participants can make their
                        winning predictions accordingly. A Participant can
                        submit his / her prediction for a match only once within
                        the contest window, there will be no option to change
                        the prediction post his submission.
                      </li>
                    </ul>
                  </li>
                  <li>
                    There will be two Leader board displayed for the Contest to
                    calculate the Points accumulated by a Participant during the
                    Contest Period: (i) current week leader board, (ii) overall
                    tournament leader board.
                  </li>
                  <li>
                    <p>Calculation for Leader board Points: </p>
                    <ul className="lowerAlpha">
                      <li>
                        Contest Participation Points = Participant will get 1
                        point (for every match prediction submitted).{" "}
                      </li>
                      <li>
                        Correct Prediction Points = Participant will get 5
                        points (for every correct match winner prediction; no
                        points in case of the match scheduled is a tie; no
                        points in case the match scheduled is washed out)
                      </li>
                      <li>
                        vzy Coupon Redemption Bonus Points = Participant will
                        get 50 (Fifty) points (for every vzy Rs. 150 coupon
                        redeemed, either by themselves or by gifting to a friend
                        / family). Every redemption will be credited to the
                        respective RMN, even if it is activated on another
                        number.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>Prizes to be won :</p>
                    <ul className="lowerAlpha">
                      <li>
                        Reward Each Participant shall receive a VZY coupon worth
                        Rs. 150 (Rupees One Hundred & Fifty only) which can be
                        redeemed by the Participant or gifted to friends &
                        family for redemption. Coupon can be redeemed with auto
                        payment mandate. Rupee 1 or Rupees 2 will be deducted
                        and auto refunded as part of auto payment mandate.
                      </li>
                      <li>
                        Weekly rewards – There will be in total 25 winners every
                        week who will win Ease My Trip Vouchers worth INR worth
                        INR 1,500 (Rs.One Thousand and Fifteen Hundred only).
                        (Week starts from Saturday & ends on Friday – Leader
                        board prizes are announced every Friday at 11 PM).
                      </li>
                      <li>
                        Top Three position of the overall leaderboard at the end
                        of the Contest Period will win two tickets (each winner)
                        for the qualifier or the Final match of the IPL 2025.
                        The winners of the IPL match tickets will be announced
                        on 24th May 2025. The tickets (if hard copy) will be
                        couriered to the winners, in case of e-tickets, it will
                        be emailed to the winners e - mail id received from the
                        winners.
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>
                      Third Party Voucher can be redeemed/used on the
                      www.easemytrip.com and shall be subject to specific terms
                      & conditions of ease my trip including but not limited to
                      terms as stated herein below:{" "}
                    </p>
                    <p>
                      INR 1500 OFF can be redeemed only against booking of
                      Flights:
                    </p>
                    <ul className="roman">
                      <li>No minimum booking conditions.</li>
                      <li>Valid till 30th June 2025.</li>
                      <li>
                        User will get INR 500 OFF on 1 pax, INR 1000 OFF on 2
                        pax and INR 1500 OFF on 3 pax bookings.
                      </li>
                      <li>Valid for both new and repeat users.</li>
                      <li>
                        Valid for redemption on all platforms of easemytrip
                        (desktop, msite, ios and android apps).
                      </li>
                      <li>Offer is valid only for flights vertical.</li>
                    </ul>
                  </li>
                  <li>
                    By participating in the Contest, the Participant gives the
                    right to the Company to use and publish their names and
                    images on its website and other promotional materials as the
                    Company may deem fit.
                  </li>
                  <li>
                    Company may substitute or change the rewards under the
                    Contest at any time without notice to Participants. The
                    Winner shall not be entitled to substitute the rewards for
                    other item(s) or exchange for cash. Rewards shall be
                    non-transferable.
                  </li>
                  <li>
                    Winner may be declared on the Company’s website, on TV
                    channel in addition to the SMS being sent out to them.
                  </li>
                  <li>
                    By participating in the Contest, each Participant agrees
                    that Participant’s name, address, telephone numbers, e-mail
                    identities or any other information that is provided by the
                    Participant (“Personal Information”) may be shared by the
                    Company with others associated with and/or assisting in
                    organizing and administering the Contest, and to send to the
                    Participant promotional information pertaining to the
                    Company, in future.
                  </li>
                  <li>
                    All taxes, levies and duties due and owing under applicable
                    and statutory laws in connection with all the winnings, if
                    any, are the sole responsibility of the Winner.
                  </li>
                  <li>
                    In the event of a death of the Winner, no claim from the
                    nominees or legal heirs of the Winner shall be entertained
                    by the Company for receiving the rewards.
                  </li>
                  <li>
                    Decision of the Company will be final and binding with
                    regard to the Contest, declaration of Winner and Prize and
                    no correspondence, objection, complaints, etc. from any
                    Participant or any third party shall be entertained in this
                    regard.
                  </li>
                  <li>
                    This Contest cannot be clubbed with any of other
                    contest/contests of the Company that are running
                    simultaneously.
                  </li>
                  <li>The Contest is subject to force majeure conditions.</li>
                  <li>
                    The Company reserves the right to change/modify/or withdraw
                    the Contest anytime at its sole discretion and without
                    giving any prior notice to the Participants. The Company
                    reserves the right to modify the terms and conditions of the
                    Contest without any prior notice to any Participants or
                    third party.
                  </li>
                  <li>
                    Participants shall be solely responsible for any costs and
                    expenses incurred towards internet connection charges,
                    e-mail transmission charges, data transfer (send/receive)
                    charges, mobile connection charges or other incidental costs
                    or expenses as may be applicable, inclusive or exclusive of
                    any other service charges, applicable taxes, levies, duties,
                    cess, etc. depending upon the service provider.
                  </li>
                  <li>
                    Mere participation in the Contest does not entitle the
                    Participant to win the Prize.
                  </li>
                  <li>
                    Company assumes no responsibility for any error, omission,
                    interruption, deletion, defect, delay in operation or
                    transmission, communications line-failure, theft or
                    destruction or unauthorized access to, or alteration of,
                    entries.
                  </li>
                  <li>
                    This offer is available for non- commercial usage only.
                  </li>
                  <li>
                    This contest is in no way sponsored, endorsed or
                    administered by, or associated with Facebook/Twitter/ or any
                    other media on which the Contest may be communicated or
                    published.
                  </li>
                  <li>
                    The images, if any used in the Contest belongs to the
                    respective person whose images are so used in the Contest.
                  </li>
                  <li>
                    Company does not make any commitment, express or implied, to
                    respond to any feedback, suggestion and, or, queries of the
                    Participants or furnish any reason or explanation for
                    inclusion and/or exclusion of any particular submission of
                    the entry of a Participants at any stage of the Contest.
                  </li>
                  <li>
                    This contest is not valid wherever prohibited by Law of any
                    State and the Subscribers from such States shall not be
                    eligible for participation in the Contest. The Contest shall
                    be subject to all applicable mandatory national and state
                    laws.
                  </li>
                  <li>
                    All decisions with respect to the Contest shall be at the
                    sole discretion of Company. In the event of any fault,
                    misunderstanding or dispute concerning any part of the
                    Contest, the decision of Company shall be final.
                  </li>
                  <li>
                    All disputes are subject to the courts situated at Delhi
                    only.
                  </li>
                  <li>
                    This document is an electronic record in terms of
                    Information Technology Act, 2000 and the Rules thereunder as
                    applicable and the amended provisions pertaining to
                    electronic records in various statutes as amended by the
                    Information Technology Act, 2000.
                  </li>
                  <li>
                    This electronic record is generated by a computer system and
                    does not require any physical or digital signatures.{" "}
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
